// src/components/Footer.js
import React from 'react';
import logopro from '../../Images/logo.png';
import '../../App.css'; // Si tienes estilos específicos para el footer

const Footer = () => {
  return (
    <section className='footer'>
      <div className='footer-container'>
        <div className='footer-section'>
          <div className='logo-img-footer'>
            <img src={logopro} alt="Logo" style={{ width: '200px' }} />
          </div>
          <p style={{ color: '#6cc24a' }}>¿QUÉ HACEMOS?</p>
          <ul>
            <li>-Venta de máquinas de coser</li>
            <li>-Refacciones | Herramientas</li>
            <li>-Reparación y mantenimiento</li>
          </ul>
        </div>
        <div className='footer-section'>
          <h4>ENLACES ÚTILES</h4>
          <ul>
            <li>Nosotros</li>
            <li>Servicios</li>
            <li>Promociones</li>
            
            <li>Descargar Catálogo</li>
          </ul>
        </div>
        <div className='footer-section'>
          <h4>¡CONTÁCTENOS!</h4>
          <ul>
            <li>📞 (664) 379-0668</li>
            <li>📧 Gis Sewing Machine</li>
            <li>📍 Av. Águila #7080, Local 9-A y 10-A, Fracc. Guaycura, Tijuana B.C.</li>
          </ul>
          <a href="https://api.whatsapp.com/send?phone=526642718857&amp;text=Solicito%20informaci%C3%B3n%20de%20un%20producto%20&amp;source=&amp;data=&amp;app_absent=" target="_self">
            <button style={{ borderRadius: 10 }}>WhatsApp</button>
          </a>
        </div>
      </div>
      <div className='Bottom-final'>
        <p>2023©  Gis Sewing Machine. Desarrollado por MobaDevs</p>
      </div>
    </section>
  );
};

export default Footer;
